import RootLayout from 'layouts/RootLayout';
import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import Breadcrumbs from 'components/Breadcrumbs';
import proxyAxios from 'api/proxyAxios';
import { endpoints } from 'api/endpoints';
import { TopArticlesCardType } from 'sections/Home/types';

const SectionHeader = dynamic(() => import('sections/Resources/BillOfLading/components/SectionHeader'));
const SectionPitch = dynamic(() => import('sections/Resources/BillOfLading/components/SectionPitch'));
const SectionAbout = dynamic(() => import('sections/Resources/BillOfLading/components/SectionAbout'));
const SectionTypes = dynamic(() => import('sections/Resources/BillOfLading/components/SectionTypes'));
const SectionImportance = dynamic(() => import('sections/Resources/BillOfLading/components/SectionImportance'));
const SectionDifferences = dynamic(() => import('sections/Resources/BillOfLading/components/SectionDifferences'));
const SectionChallenges = dynamic(() => import('sections/Resources/BillOfLading/components/SectionChallenges'));
const SectionSolutions = dynamic(() => import('sections/Resources/BillOfLading/components/SectionSolutions'));
const SectionSteps = dynamic(() => import('sections/Resources/BillOfLading/components/SectionSteps'));
const SectionTakeaways = dynamic(() => import('sections/Resources/BillOfLading/components/SectionTakeaways'));
const SectionSignUp = dynamic(() => import('sections/Resources/BillOfLading/components/SectionSignUp'));
const SectionFaq = dynamic(() => import('sections/Resources/BillOfLading/components/SectionFaq'));
const SectionCallToAction = dynamic(() => import('sections/Resources/BillOfLading/components/SectionCallToAction'));
const SectionRelatedPosts = dynamic(() => import('sections/Resources/BillOfLading/components/SectionRelatedPosts'));

interface IProps {
  articles: TopArticlesCardType[];
}

export default function BillOfLadingPage({ articles }: IProps) {
  return (
    <div className="bill-of-lading">
      <div className="container">
        <Breadcrumbs mTop={64} mode="light" links={[{ title: 'Bill of Lading', href: '' }]} />
      </div>
      <SectionHeader/>
      <SectionPitch/>
      <SectionAbout/>
      <SectionTypes/>
      <SectionImportance/>
      <SectionDifferences/>
      <SectionChallenges/>
      <SectionSolutions/>
      <SectionSteps/>
      <SectionTakeaways/>
      <SectionSignUp/>
      <SectionFaq/>
      <SectionCallToAction/>
      <SectionRelatedPosts articles={articles}/>
    </div>
  );
}

export const getStaticProps = async () => {
  const meta = {
    title: 'Understanding Bill of Lading | DF Alliance',
    description:
      'Access essential resources like Bill of Lading, Blacklist, and more with DF Alliance to enhance your knowledge and optimize your global freight operations.',
    path: '/resources/bill-of-lading',
  };
  try {
    const { data: articles } = await proxyAxios(endpoints.blog.previewArticles + '?limit=3');

    return { props: { articles, ...meta } };
  } catch (e) {
    console.log('endpoints.blog.previewArticles', e);
  }

  return { props: { articles: [], ...meta } };
};

BillOfLadingPage.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
